import { runtime } from '../runtime';
import * as webNetwork from './web';
import * as nativeNetwork from './native';

export const network = runtime.isNative() ? nativeNetwork : webNetwork;
export default network;
